import { MortgageRates } from '../../../../interfaces/mortgages';

export const prepareDataByMortgageRates = (data: MortgageRates) => {
  if (!Array.isArray(data)) return [];

  return data.map(({ programName, rate, url }) => ({ label: programName, value: rate, href: url }));
};
